import { AxiosInstance } from 'axios';
import { getExportConfig, handleFileExport } from '../../../../../../helpers/fileExport';
import { TRIAL_BALANCE_REPORT } from '../endpoint';
import { TrialBalanceReportRequestModel } from '../models/TrialBalanceReportRequestModel';

export const exportPDF =
  (axios: AxiosInstance) =>
  async (params?: TrialBalanceReportRequestModel): Promise<void> => {
    return await axios
      .get(`${TRIAL_BALANCE_REPORT}`, {
        params: { ...params },
        ...getExportConfig(params),
      })
      .then(response => {
        handleFileExport(response, {
          file_type: params?.file_type,
          filename: 'trial-balance-report',
        });
      });
  };
